import Menu from './Compartido/Menu.jsx';
import TextosGraciasTpv from './GraciasTpv/TextosGraciasTpv.jsx';
import Footer from './Compartido/Footer.jsx';

const GraciasTpv = (props) => {
    return (
        <main>
            <Menu
                idiomas={props.idiomas}
                lang={props.lang}
                config={props.websgrupo}
                ruta={props.ruta}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
            />
            <TextosGraciasTpv />
            <Footer
                datos={props.websgrupo}
                lang={props.lang}
                ruta={props.ruta}
                logos_pie={props.logos_pie}
                websgrupo={props.websgrupo}
            />
        </main>
    )
}

export default GraciasTpv;
